// @flow
import * as React from 'react';
import styled from 'styled-components';
import ModalRoot from './ModalRoot';

const StyledModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
`;

declare var document: any;

type ModalProps = {
  children: React.Node,
  onRequestClose: Function,
  isOpen: boolean,
  closeOnBackgroundClick: boolean,
};

class Modal extends React.Component<ModalProps> {
  UNSAFE_componentWillMount() {
    document.body.classList.toggle('is-locked', this.props.isOpen);
  }

  UNSAFE_componentWillReceiveProps(props: ModalProps) {
    document.body.classList.toggle('is-locked', props.isOpen);
  }

  componentWillUnmount() {
    document.body.classList.toggle('is-locked', this.props.isOpen);
  }

  handleBackgroundClick = (e: SyntheticEvent<HTMLDivElement>) => {
    if (e.currentTarget !== e.target) return;
    if (this.props.closeOnBackgroundClick) this.props.onRequestClose();
  };

  render() {
    if (!this.props.isOpen) return null;

    return (
      <ModalRoot>
        <StyledModalBackground onClick={this.handleBackgroundClick}>
          {this.props.children}
        </StyledModalBackground>
      </ModalRoot>
    );
  }
}

export default Modal;
